const validators = {
  u_name: {
    presence: {
      message: "^errors.register.invalid_email"
    },
    email: {
      message: "^errors.register.invalid_email"
    }
  }
};
export default validators;
